import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, DialogService } from 'src/app/services';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from 'lodash';

@Component({
  selector: 'esc-choose-file',
  templateUrl: './choose-file.component.html',
  styleUrls: ['./choose-file.component.scss']
})
export class ChooseFileComponent implements OnInit {
  public listData = [];  
  public selectedFile;

  constructor(
    public authService: AuthService,
    public media: MediaObserver,
    public dialogRef: MatDialogRef<ChooseFileComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.prepareData();
  }

  prepareData() {
    let temp = _.clone(this.data);
    temp = temp.map(e => {
      e.relativePath = this.media.isActive('lt-sm') ? _.truncate(e.relativePath, { length: 25 }) : _.truncate(e.relativePath, { length: 70 });
      return e;
    })
    this.listData = temp;
  }

  filterFiles() {
    let temp = _.clone(this.data);
    temp = temp.filter(e => {
      return e.fileEntry.name == this.selectedFile.fileEntry.name;
    })
    
    this.dialogRef.close(temp);
  }

}